import { api } from "@/redux/api";
import { useRequest } from "ahooks";

export const useFacilityCategoryOptions = () => {
    const { data = [], loading, error } = useRequest(async () => {
        const res = await api.getFacilityCategory();
        if (Array.isArray(res.data)) {
            return res.data.map(item => {
                return {
                    label: item.name,
                    value: item.id
                }
            })
        } else {
            return []
        }
    });
    return {
        data,
        loading,
        error,
    }
}